export default "__VITE_ASSET__DQqUEuAG__"